import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

import nurbs from 'nurbs';

export default class ENurbsCurve extends OBase {
  update () {
    let pointsTree = this.getVector3Input('Vertices', false);
    let degreeTree = this.getFloatInput('Degree');
    let periodicTree = this.getBoolInput('Periodic');

    let outputCurve = this.outputs['Curve'].paramObject;
    let outputLength = this.outputs['Length'].paramObject;

    let dataTrees = [pointsTree, degreeTree, periodicTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outputCurveTree = new Geometry.DataTree();
    let outputLengthTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      let paths = this.createPolyline(outDataTrees[0].branches[i], outDataTrees[1].branches[i][0], outDataTrees[2].branches[i][0]);
      outputCurveTree.add(paths, outDataTrees[0].paths[i]);

      let length = 0;
      let path = paths[0];
      for (let i = 0, n = path.length - 1; i < n; i++) {
        let p0 = path[i];
        let p1 = path[i + 1];
        let dx = p0.X - p1.X;
        let dy = p0.Y - p1.Y;
        length += Math.sqrt(dx * dx + dy * dy);
      }
      outputLengthTree.add(length, outDataTrees[0].paths[i]);
    }

    outputCurve.value = outputCurveTree;
    outputLength.value = outputLengthTree;
  }

  getKnotCount (order, cvCount) {
    return order + cvCount - 2;
  }

  makePeriodicUniformKnotVector (order, cvCount, delta = 0.1) {
    const knotCount = this.getKnotCount(order, cvCount);

    let knots = [];

    for (let i = order - 2, k = 0.0; i < knotCount; i++, k += delta) {
      knots[i] = k;
    }

    for (let i = order - 3, k = -delta; i >= 0; i--, k -= delta) {
      knots[i] = k;
    }

    return knots;
  }

  createPolyline (points, degree, periodic) {
    // https://developer.rhino3d.com/api/RhinoCommon/html/M_Rhino_Geometry_NurbsCurve_Create.htm
    // opennurbs_knot.cpp
    // - ON_MakePeriodicUniformKnotVector
    // https://developer.rhino3d.com/guides/opennurbs/periodic-curves-and-surfaces/

    let paths = [];
    let path = [];

    //degreeがpoint.length未満であることを保証する
    degree = Math.min(points.length - 1, degree); 
    
    /*
    global.debugger.addPoints(points.map(p => {
      let copied = p.clone()
      copied.z *= -1
      return copied
    }), new THREE.Color(0xff0000))
    */

    let curve;
    if (periodic) {
      curve = nurbs({
        points: points.map(p => [p.x, p.y]),
        degree: degree,
        boundary: 'closed'
      });
    } else {
      curve = nurbs({
        points: points.map(p => [p.x, p.y]),
        degree: degree,
        boundary: 'clamped'
      });
    }

    let domain = curve.domain[0];
    let dl = domain[1] - domain[0];

    const resolution = points.length * 20;
    let step = 1.0 / resolution;

    // https://developer.rhino3d.com/api/RhinoCommon/html/M_Rhino_Geometry_Curve_ToPolyline_2.htm
    let samples = [];
    for (let t = 0; t <= 1.0; t += step) {
      let tt = dl * t + domain[0];
      let p = curve.evaluate([], tt);
      samples.push(p);
    }

    let n = periodic ? samples.length - 1 : samples.length;
    for (let j = 0; j < n; j++) {
      let sample = samples[j];
      path.push(new ClipperLib.DoublePoint(sample[0], sample[1]));
    }

    path.reverse();
    if (GHMath.isClockwise(path)) {
      path.reverse();
    }
    paths.push(path);
    return paths;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ENurbsCurve.js